import { Popconfirm } from 'antd';

export default function ButtonConfirm({
  children,
  title,
  description,
  onConfirm = async () => {},
  onCancel = () => {},
}) {
  const confirm = async () => {
    await onConfirm();
  };

  const cancel = () => {
    onCancel();
  };

  return (
    <Popconfirm
      title={title}
      description={description}
      onConfirm={confirm}
      onCancel={cancel}
      okText="确认"
      cancelText="取消"
    >
      {children}
    </Popconfirm>
  );
}
